const content: { [key: string]: any } = {
  pageTitle: {
    title: "Leadership Seminar",
    esanTitle: "Leadership Training Seminar",
  },
  bannerTile: {
    earned: "Great job! You have qualified for the {tripName}.",
    automaticallyApproved: "Congratulations! You’re Qualified for the {tripName}!",
    tracking: "Keep going so you can join the {tripName}!",
    notTracking: "You are not currently tracking to join the {tripName}.",
    description: "For final confirmation of the trip qualification status, please consult with your local sales team.",
    descriptionAlternate:
      "For final confirmation of the trip qualification status, please consult with your LGS representative.",
    notEligible: "You are not currently eligible for the {tripName}.",
    noLongerPossible: "It is no longer possible for you to join the {tripName}.",
    comingSoon: "The year ahead belongs to you.",
    comingSoonDescription:
      "Happy new Performance Year! Information for the new performance year is coming soon. Updated information will become available when last performance year's baselines have been confirmed.",
  },
  progressTile: {
    title: "Track your progress",
    requirementLabel: "You've met <1>{current} of {needed}</1> requirements to earn this incentive.",
  },
  requirements: {
    exempt: "You are currently exempt from having to meet this requirement.",
    exemptTag: "You're exempt from this requirement.",
    sectionHeader: "How do I qualify? Here is the list of requirements.",
    pathViewSectionHeader: "How do I qualify? Track your progress.",
    tripCountText:
      "As of the most recent Performance Year, you have qualified for the Leadership Seminar <1>{count}</1> times.",
    subtext:
      "Founders Platinum through Founders Emerald ABOs must grow by <1>{fqs}</1> FQs compared to the previous fiscal year. Founders Platinum & Founders Ruby must also generate a minimum of <1>{monthlyGpv}</1> Group PV monthly. As an alternative for the first timers, Founders Platinum & Founders Ruby can generate a total of <1>{annualGpv}</1> Group PV in the fiscal year <1>{performanceYear}</1>. Qualified Diamond leaders are invited automatically. Click 'Learn More' for more information.",
    subtextWithRubyPV:
      'ABOs who qualify as a new Founder Platinum through Founder’s Sapphire are automatically qualified for the Leadership Seminar. ABOs who requalify Founders Platinum through Emerald must grow by <1>{minFQs}</1> FQs compared to the previous fiscal year and generate <1>{minRubyPV}</1> Ruby PV in the fiscal year <1>{performanceYear}</1>. In addition, if you qualify as Emerald, you must also be an Emerald Bonus Recipient. ABOs who qualify as new Emerald through Founders Diamond or requalify as Founders Emerald through Founders Diamond must only be an Emerald Bonus Recipient. GAR-Level ABOs must be an Emerald Bonus Recipient or follow the criteria mentioned above. Click "Learn More" for more information.',
    description: "You’ve met <1>{current} of {needed}</1> requirements to earn this incentive.",
    monthlyRequirements: "Monthly Requirements",
    annualRequirements: "Annual Requirements",
    thisRequirementMustBeMet: "This requirement must be met.",
    oneOfTheseMustBeMet: "One of these two requirements must be met.",
    monthlyGpvStatus: "Monthly GPV Status",
    option1: "Option 1",
    option2: "Option 2",
    option3: "Option 3",
    optionOne: "Option 1 – Founder’s Platinum - Founder’s Sapphire with highest ever below Diamond",
    optionTwo: "Option 2 – Founder’s Platinum - Founder’s Sapphire with highest ever below Diamond",
    optionThree: "Option 3 – Emerald - Founder’s Diamond",
    two: "two",
    three: "three",
    optionOneKR: "Option 1 - Meet these three requirements",
    optionTwoKR: "Option 2 - Meet these two requirements",
    personal: {
      title: "{volume} Annual PPV",
      description: "Annual PPV excludes PV from Top-up transactions.",
      subDescription: "",
    },
    ruby: {
      title: "{volumeRuby} Annual Ruby PV",
      description: "",
      subDescription: "",
    },
    annualPAPV: {
      title: "{volumeAnnualPapv} Annual PAPV",
      description: "Annual PAPV excludes PV from Top-up transactions.",
      subDescription: "",
    },
    basisCheckForFoundersPlatinumWithGe: {
      title: "Qualified Founders Platinum Pin or Above",
      description: "Must qualify Founders Platinum to earn this incentive.",
      subDescription: "",
    },
    basisCheckForFoundersPlatinumWithEq: {
      title: "Qualified Founders Platinum Pin",
      description: "Must qualify Founders Platinum to earn this incentive.",
      subDescription: "",
    },
    basisCheckForFoundersPlatinumAward: {
      title: "Qualified Founders Platinum Award or Above",
      description: "",
      subDescription: "",
    },
    basisCheckForFoundersPlatinumEmerald: {
      title: "Qualified Founders Platinum or Emerald",
      description: "In-Market Pin Tracking",
      subDescription: "Founders Platinum",
    },
    basisCheckForFoundersPlatinumEmeraldBonus: {
      title: "Qualified Founders Platinum or Emerald Bonus Recipient",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    basisCheckForEmerald: {
      title: "Qualified Emerald",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    basisCheckForEmeraldWithGe: {
      title: "Qualified Emerald Pin or Above",
      description: "Must qualify Emerald Bonus Recipient",
      subDescription: "",
    },
    emeraldBonusRecipient: {
      title: "Qualified Emerald Bonus Recipient",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    basisCheckForDiamond: {
      title: "Qualified Diamond",
      description: "In-Market Pin Tracking",
      subDescription: "Diamond",
    },
    qMonths: {
      title: "{volumeQMonths} Q Months",
      titleMobile: "{current}/{target} Q Months",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    ytdVcsPercentageOfPpv: {
      title: "{currentVcs}/60% Annual VCS of PPV",
      description: "",
      subDescription: "",
    },
    group: {
      title: "{volumeAnnualGpv} Annual GPV",
      description: "",
      subDescription: "",
    },
    annualGpv: {
      title: "{volumeAnnualGpv} Annual GPV",
      titleMobile: "{current}/{target} Annual GPV",
      description: "",
      subDescription: "",
    },
    annualRuby: {
      title: "{volumeRuby} Annual Ruby PV",
      description: "",
      subDescription: "",
    },
    monthlyGpv: {
      title: "{volumeMonthlyGpv} Monthly GPV",
      titleMobile: "{current}/{target} Monthly GPV",
      description: "",
      subDescription: "",
    },
    newFqs: {
      title: "+{newFqs} New FQs",
      description:
        "To meet this requirement, you must grow your FQ count by {totalFqs} compared to the previous performance year.",
      subDescription: "",
    },
    basisCheckForPggKickerWithEq: {
      title: "Qualified PGG Kicker Award",
      description: "",
      subDescription: "",
    },
    basisCheckForEmeraldParticipantWithEq: {
      title: "Qualified Emerald Bonus Recipient",
      description: "Must qualify Emerald Bonus Recipient to earn this incentive.",
      subDescription: "",
    },
    basisCheckForDiamondParticipantWithEq: {
      title: "Qualified Diamond Participant",
      description: "Must qualify as Diamond Participant to earn this incentive.",
      subDescription: "",
    },
    derivedNewOrRequalifiedAward: {
      title: "First time or first year requalified of new Award",
      firstTimeTitle: "First time or first year requalified of new Award",
      reQualifiedTitle: "Re-qualified Award",
      description: "",
      subDescription: "",
      trackingAwardLevel: "{performanceYear} Tracking Award Level",
      newAwardLevel: "New Award Level",
      firstYearRequalification: "First Year Requalification",
    },
    sponsorCountAnnualWithGe: {
      title: "{target}+ New ABOs",
      description: "Sponsor {target} new ABOs in this performance year.",
      subDescription: "",
    },
    derivedGrowQMonth: {
      title: "{target} Q Months",
      description: "Achieve {target} Q Months in this performance year.",
      subDescription: "",
    },
    derivedMaintainFQOrGrowGPV: {
      title: "+{target} FQ Growth or Maintain FQs & Grow GPV",
      description: "Meet either FQ growth requirement or maintain FQs and grow GPV.",
      subDescription: "",
    },
    basisCheckForQualifiedEmeraldParticipant: {
      title: "Qualified Emerald Bonus Recipient",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    coreAward: {
      title: "Core Award Requirement",
      description: "",
      subDescription: "",
    },
    maintainLSVolume: {
      title: "Maintain Leadership Seminar Volume",
      dashboardTitle: "Leadership Seminar Volume",
      dashboardTitleMobile: "Leadership Seminar",
    },
    growthOrMaintainCheckForEmerald: {
      title: "Maintain Pin Level",
    },
    growthOrMaintainCheckForgarExecutiveDiamond: {
      title: "Maintain Pin Level",
    },
    basisCheckForFoundersPlatinum: {
      title: "Qualified Founder's Platinum",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    basisCheckForFoundersPlatinumAndEmeraldBonus: {
      title: "Qualified Founder’s Platinum and Emerald Bonus Recipient",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    garBasisCheckForFoundersPlatinumAndEmeraldBonus: {
      title: "Qualified Founders Platinum and Emerald Bonus Recipient",
      description: "In-Market Pin Tracking",
      subDescription: "Emerald",
    },
    currentPYCurrentAwardCheckEmeraldUsingLt: {
      title: "Qualified Founders Platinum Pin",
      description: "Must be below Emerald to qualify via this path.",
      subDescription: "",
    },
    basisCheckForEmeraldWithEq: {
      title: "Qualified Emerald",
      description: "Must qualify as Emerald to earn this incentive.",
      subDescription: "",
    },
    maintainPinLevel: {
      title: "Maintain Pin Level",
      description: "In-Market Pin Level",
      subDescription: "Emerald",
    },
    pinRequirement: {
      title: "Pin Requirement",
      description: "PY{prevYear} In-Market Pin",
      subDescription: "Emerald",
    },
    viewDetails: "View Details",
    FQRequirement: {
      title: "Grow {Target} New FQ",
      description: "",
      subDescription: "",
    },
  },
  newFqs: {
    baseline: "PY{py} Baseline",
    avgBaseline: "Baseline",
    current: "Current YTD",
    tracking: "Tracking",
    exempt: "You are currently exempt from having to meet this requirement.",
    exemptTag: "You're exempt from this requirement.",
  },
  compareTable: {
    title: "Compare with Previous Year:",
    fqStatus: "<1>PY{prevYear}</1> <2>Status</2>",
    fqTracking: "<1>PY{currentYear}</1> <2>Tracking</2>",
    requiredFqs: "Required FQs",
    currentYtd: "Current YTD",
    exempt: "You are currently exempt from having to meet this requirement.",
    exemptTag: "You're exempt from this requirement.",
    previousPy: "Previous PY",
    needed: "Needed",
  },
  legend: {
    earned: "Earned",
    potential: "Potential",
    notEarned: "Not Earned",
    unavailable: "Unavailable",
  },
  pqRequirementsTitle: "{achievedPqs} out of {totalPqs} PQs",
  pqRequirementsDescription: "",
  amountOfPQs: "{val} PQs",
  amountOfPlusPQs: "{val}+ PQs",
  dynamicRangeOfPQs: "{val1}-{val2} PQs",
  tagMetRequirement: "You've met this requirement.",
  additionalVolumeTag: "Additional {volume} Needed",
  onTrackTag: "On Track",
  achievedTag: "Achieved",
  notTracking: "Not Tracking",
  currentFqs: "{fqs} FQs",
  previousFqs: "{fqs} FQs",
  pyLabel: "PY{performanceYear}",
  average: "Average",
  abo: "ABO",
  target: "Target: {target}",
  or: "Or",
  qMonthRequirement: {
    title: "{qs} Q Months",
    currentYtd: "Current YTD",
    tracking: "Tracking",
    target: "Target",
  },
  pathView: {
    // Path selection
    pathTitle: "Path {pathNumber}",
    pathSelectionLabel: "Select a qualification path",
    selectedSuffix: "(Selected)",
    requirementsLabel: "Requirements",

    // Path status messages
    eitherOrRequirement: "Either or requirement: {metCount} of {totalCount} conditions met.",
    requirementMet: "Requirement met.",
    requirementNotMet: "Requirement not met.",
    eitherOrConditionMet: "Either or condition: at least one condition met",
    eitherOrConditionNotMet: "Either or condition: no conditions met",

    // Tile content
    currentYtd: "Current YTD",
    needed: "Needed",
    newLegTitle: "{target}+ New ABOs",
    newLegDescription:
      "To meet this requirement, you must sponsor {target} or more new ABOs compared to the previous performance year.",
    newLegIconsLabel: "New ABO sponsorship progress",
    completedLeg: "Sponsored",
    remainingLeg: "Remaining",
    firstTimeTitle: "First time or first year requalified of new Award",
    trackingAwardLevel: "{performanceYear} Tracking Award Level",
    newAwardLevel: "New Award Level",
    firstYearRequalification: "First Year Requalification",
    volumeTileDescription:
      "To stay on track to meet the required annual {volumeType}, your desired target is an average of {monthlyTarget} {volumeType} per month. Use the dial to see how you're tracking for the performance year.",
    volumeTypeLabels: {
      personal: "PPV",
      group: "GPV",
      ruby: "Ruby PV",
      annualGpv: "GPV",
    },

    // Q Count tile content for LS PathView
    qCountTile: {
      title: "{target} Q Months and Increase Q Months",
      pyBaseline: "PY{perfYear} Baseline",
      currentYtdQMonths: "Current YTD Q Months",
      potentialQMonths: "Potential Q Months",
      viewBaselineTable: "View previous performance year Q month breakdown",
      viewYtdTable: "View current year-to-date Q month breakdown",
      potentialAriaGreen: "You are on track to meet the Q month requirement.",
      potentialAriaYellow: "You are at the minimum Q months; keep going to stay on track.",
      potentialAriaRed: "You are not currently on track to meet the Q month requirement.",
    },

    // Requirement summary labels (keyed by API ReqName for path cards)
    basisCheckForFoundersPlatinumWithGe: "FPL+",
    basisCheckForPlatinumWithEq: "Platinum+",
    basisCheckForEmeraldParticipantWithEq: "Emerald Bonus Recipient",
    basisCheckForDiamondParticipantWithEq: "Diamond Bonus Recipient",
    derivedMaintainFQOrGrowGPV: "+{target} FQ or Maintain FQ & Volume Growth",
    derivedNewOrRequalifiedAward: "First time or first year requalification of new award",
    personal: "{volume} Annual PPV",
    sponsorCountAnnualWithGe: "{target}+ New ABOs",
    derivedGrowQMonth: "{target} Q Months and Increase Q Months",

    // Expanded view header descriptions (keyed by sorted requirement names joined with underscore)
    pathHeaderDescriptions: {
      basisCheckForFoundersPlatinumWithGe_derivedMaintainFQOrGrowGPV:
        "Must qualify Founders Platinum or above, with either FQ or Volume Growth",
      basisCheckForEmeraldParticipantWithEq_personal_sponsorCountAnnualWithGe:
        "Must qualify Emerald Bonus Recipient, with {volume} Annual PPV, and {target} or more new ABOs",
      derivedNewOrRequalifiedAward: "First time or first year requalification of new award",
      basisCheckForDiamondParticipantWithEq: "Must qualify Diamond Bonus Recipient",
      basisCheckForFoundersPlatinumWithGe: "Must qualify Founders Platinum or above",
      basisCheckForPlatinumWithGe_derivedGrowQMonth:
        "Must qualify with Platinum Pin, and have at least {target} qualified month, while increasing {ytdQCount} Q month, compares to the previous performance year",
    },

    // Badge tile content (keyed by API badge name)
    badges: {
      basisCheckForFoundersPlatinumWithGe: {
        title: "Qualified Founders Platinum Pin or above",
        description: "In-Market Pin Tracking",
        subDescription: "Founders Platinum",
      },
      basisCheckForPlatinumWithGe: {
        title: "Qualified Platinum Pin or above",
        description: "In-Market Pin Tracking",
        subDescription: "Platinum",
      },
      basisCheckForPlatinumWithEq: {
        title: "Qualified Platinum Pin or above",
        description: "Must qualify Platinum Pin or above to earn this incentive.",
      },
      basisCheckForEmeraldParticipantWithEq: {
        title: "Qualified Emerald Bonus Recipient",
        description: "Must qualify Emerald Bonus Recipient to earn this incentive.",
      },
      basisCheckForDiamondParticipantWithEq: {
        title: "Qualified Diamond Bonus Recipient",
        description: "Must qualify as Diamond Participant to earn this incentive.",
      },
    },
  },
  accessibility: {
    exempt: "Exempt: {requirementType}. You are currently exempt from having to meet this requirement.",
    status: "{requirementType} requirement: {current} of {total}. Status: {status}.",
    exemptPrefix: "Exempt: ",
    exemptInfo: "Information about exemption",
  },
  volumeDetails: {
    title: "Leadership Seminar Volume Details",
    groupPV: "Group PV",
    noOfFQ: "# of FQ's",
    volumeGenerated: "Volume Generated from FQ",
    totalLSV: "Total LSV",
    pyLabel: "PY{performanceYear}",
    pyYtdLabel: "PY{performanceYear} YTD",
    calculationNote: "Leadership Seminar Volume Calculation - Group PV + (Number of FQs * 10,000)",
  },
  footer: {
    finalConfirmation:
      "For final confirmation of the trip qualification status, please consult with your local sales team.",
  },
  tooltips: {
    emeraldOrHigherTooltip:
      "If you are Emerald or higher, you must qualify as Emerald Bonus Recipient to meet this requirement.",
    pinRequirementTooltip:
      "You can either maintain your pin from last year or drop one level to meet this requirement.",
    foundersPlatinumTooltip:
      "Achieving the Founders Platinum pin is mandatory for ABOs, along with maintaining last year's Leadership Seminar volume.",
    maintainLSVolumeTooltip: "You are currently exempt from having to meet this requirement.",
  },
} as const;

export default content;
